import decounce from 'debounce';
import { TIME_TRIGGER } from '@/utils/constants';
import { searchCustomers } from '@/utils/customerSearch';

/**
 * Mixin tìm kiếm nhà cung cấp (Customer) theo searchText.
 * Dùng cho component có StockSlipBase (stockSlip.providerName / stockSlip.providerId).
 *
 * Component dùng mixin này cần:
 *   - data: stockSlip (object có providerId, providerName)
 *   - template: :providers="providerOptions" @onInputChangeProvider="onInputChangeProvider"
 *
 * Mixin cung cấp:
 *   - data: providerOptions
 *   - methods: onInputChangeProvider
 */
export default {
  data() {
    return {
      providerOptions: [],
    };
  },
  created() {
    this._debounceSearchProvider = decounce(async function () {
      const text = this.stockSlip.providerName?.trim();
      if (!text) return;
      this.providerOptions = await searchCustomers(text, 10, true);
    }.bind(this), TIME_TRIGGER);
  },
  methods: {
    onInputChangeProvider(text) {
      this.stockSlip.providerName = text;
      if (!text || !text.trim()) {
        this.stockSlip.providerId = null;
        this.providerOptions = [];
        return;
      }
      this._debounceSearchProvider();
    },
  },
};
